module.exports = __webpack_public_path__ + "img/first-canadian_breakdown-card.87786749.png";